function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { domExists } from '@domain-group/fe-helper';
import { getElementTop, getScrollPos } from '../../utils/dom-helpers';
import * as styles from './sticky-sidebox.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getRefValue = func => ref => domExists() && ref.current ? func(ref.current) : 0;
var getRefTop = getRefValue(getElementTop);
var getRefHeight = getRefValue(element => element.clientHeight);
var StickySidebox = props => {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSticky = _useState2[0],
    setSticky = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBottom = _useState4[0],
    setBottom = _useState4[1];
  var sideboxRef = useRef();
  var sideboxHeightRef = useRef();
  var getSidebarBottom = () => getRefTop(props.sidebarBottom) - getRefHeight(sideboxHeightRef);
  var handleScroll = () => {
    var scrollPos = getScrollPos();

    // This is the position of the sidebox when it's sticky, just below the top edge of the viewport.
    var stickyTopEdge = scrollPos + props.topEdgeOffset;
    var shouldBeSticky = getRefTop(sideboxRef) < stickyTopEdge;
    if (isSticky !== shouldBeSticky) {
      setSticky(shouldBeSticky);
    }
    var shouldBeBottom = getSidebarBottom() < stickyTopEdge;
    if (isBottom !== shouldBeBottom) {
      setBottom(shouldBeBottom);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  });
  var mainStyle = [styles.sidebox, isSticky && styles.sticky(props.topEdgeOffset), isBottom && styles.bottom(getSidebarBottom())];
  return ___EmotionJSX("div", {
    "data-testid": "sticky-sidebox",
    ref: sideboxRef
  }, ___EmotionJSX("div", {
    ref: sideboxHeightRef,
    css: mainStyle
  }, props.children));
};
StickySidebox.propTypes = {
  sidebarBottom: PropTypes.shape({
    current: PropTypes.shape()
  }),
  children: PropTypes.node.isRequired,
  property: PropTypes.shape({}),
  topEdgeOffset: PropTypes.number,
  media: PropTypes.shape({
    desktop: PropTypes.bool,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool
  })
};
StickySidebox.defaultProps = {
  sidebarBottom: {},
  property: {},
  media: {},
  topEdgeOffset: 8
};
export default StickySidebox;